export const apiPrefix = '/api'

const endpointConfig = {
    signIn: '/sign-in',
    signOut: '/sign-out',
    signUp: '/sign-up',
    signotp: '/sendotp',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    // Face service paths, relative to FACE_API_URL (not the Portal API).
    faceEnroll: '/api/face/enroll',
    // Validate tab: one frame, matched on the face service against the
    // signed-in employee's own face data only.
    faceValidate: '/api/face/validate',
    // Every legacy face (public /reg_face screen only).
    faceRecognize: '/api/face/recognize',
    // Portal API (VITE_API_URL) — records the enrolment and photo reviews.
    faceRegisterValidate: '/empfaceregister/validate',
    faceRegisterSave: '/empfaceregister/save',
    faceRegisterStatus: '/empfaceregister/status',
    faceRegisterReview: '/empfaceregister/review',
    faceRegisterEmployeeStatus: '/empfaceregister/employeestatus',
    faceRegisterEmbeddings: '/empfaceregister/embeddings',
    // Admin » Register Face: register / update another employee's face.
    faceRegisterAdminSave: '/empfaceregister/adminsave',
    faceRegisterAdminUpdate: '/empfaceregister/adminupdate',
    // Employee List » Face Register: delete one registered photo
    // (?docId=&deletedByEmpCode=; deletedByEmpCode = the signed-in user).
    faceRegisterDeletePhoto: '/empfaceregister/deletephoto',
    // One face register photo: /photo/{docRefNumber} → image, 404 if missing.
    // (/view/Viewing returns a grey default image for face photos.)
    faceRegisterPhoto: '/empfaceregister/photo',
}

export default endpointConfig
